import { render } from "./MediaGallery.vue?vue&type=template&id=05ee0357&scoped=true"
import script from "./MediaGallery.vue?vue&type=script&lang=js"
export * from "./MediaGallery.vue?vue&type=script&lang=js"

import "./MediaGallery.vue?vue&type=style&index=0&id=05ee0357&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ee0357"]])

export default __exports__